import React, { useEffect, useState } from 'react';
import NominationCard from '../components/nominationcard.js';
import {ReactComponent as Close} from '../assets/svgs/close.svg';
import {ReactComponent as Search} from '../assets/svgs/search.svg';
import NominationsLeft from '../components/nominationsleft.js';
import axios from 'axios';
import { useMst } from '../models/root';
import { observer } from "mobx-react-lite";
import apis from "../assets/js/apis.js";

const APPLY_WHEN_SENDING_TO_NOMINATIONS_PAGE = 5;
const APPLY_WHEN_YOU_NEED_MORE_UNNOMINATED_PEOPLE = 9;

const Nominate= observer(()=>{

    const [nominated, setNominated] = useState(false);
    const [closeBottom, setCB] = useState(false);
    const [closeMiddle, setCM] = useState(false);
    const [selected, setSelected] = useState(false);
    const [copied,setCopied] = useState(false);
    const [count,setCount] = useState("x")
    const {variables} = useMst();

    const handlescroll=(e)=>{
        let element=e.target;
        if(element.scrollHeight - element.scrollTop === (1.2*element.clientHeight)){
            variables._e(0);
            variables._e(APPLY_WHEN_YOU_NEED_MORE_UNNOMINATED_PEOPLE);
        }
    };

    useEffect(()=>{
        /*if(props.location.state.fromHome==1){
            setCM(true);
        };*/
        variables._e(0);
        variables._e(APPLY_WHEN_SENDING_TO_NOMINATIONS_PAGE);
    },[])

    const copyFunc = () => {
        setCopied(true);
        setTimeout(()=>{
            setCopied(false);
        },2000)
    }
    let x;
    useEffect(()=>{
        const options = {
            headers: {'Authorization': `Bearer ${variables.access_token}`}
          };
        x = setInterval(
            ()=>{
            axios.get(apis.isNominated,options).
            then(response=>{
              if(response.data.success==1){
                  if(response.data.count>=5){
                    setNominated(true);
                    if(variables.nominated==false){
                        variables._nominated(true);
                    }
                  }
                  setCount(5-response.data.count)
              }
            },error=>{;})},5000)

            return clearInterval(x);
    }
    ,[])

    useEffect(()=>{
        if(nominated==true){
            clearInterval(x);
        }
    },[nominated])


    return(
        <div class="h-full w-full ">
            <div class="overflow-hidden h-1.5/6 absolute w-full">
                <div class="mb-4 mt-8 w-full text-lg text-center"><p class="font-bold">Nominate</p></div>
                {!nominated&&<div class="w-full flex text-center justify-around mb-8"><p class="w-8/12 text-sm">You need 5 nominations from your college to confirm your identity</p></div>}
                {nominated&&<div class="w-full">
                    <div class="w-2/12 float-left h-4 relative"></div>
                    <div class="w-8/12 float-left relative h-8">
                        <input type="text" class="rounded h-full w-full" />
                        <Search class={selected?"absolute top-2 right-2":"absolute top-2 opacity-20 right-2"}/>
                        </div>
                </div>} 
            </div>
            {!closeMiddle&&<div class="absolute bg-white h-2/6 z-10 top-1/4 w-full">
                <div class='border-t-2 w-full border-black h-8'></div>
                <div class="absolute top-2 right-2 h-5 w-5" onClick={()=>setCM(true)}><Close/></div>
                <NominationCard name="Sarthak Aggarwal" email="sarthak.ib@gmail.com" dummy={true}/>
                <div class="w-full flex text-center absolute bottom-3 text-sm justify-around">
                    <p class="w-8/12">Your nomination will look like this to other people</p>
                </div>
            </div>}
            
            {!closeBottom&&<div class="h-2.5/6 z-10 bg-white absolute bottom-0 w-full">
                <div class='border-t-2 absolute w-full border-black h-0.25'></div>
                <div class="absolute top-2 right-2 h-5 w-5" onClick={()=>setCB(true)}><Close/></div>
                {!copied&&<div onClick={copyFunc} class="absolute z-20 top-1/4 w-6/12 left-1/4 bg-blue-700 text-white text-lg text-center rounded"><p class="p-4">horsey.tech</p></div>}
                {copied&&<div class="absolute z-20 top-1/4 w-6/12 left-1/4 border-2 border-blue-700 text-blue-700 text-lg text-center rounded"><p class="p-4">copied</p></div>}
                <div class="absolute left-6 top-2/4 w-10/12 bg-pink-200 text-center font-bold rounded"><p class="p-4">INVITE COLLEGE FRIENDS</p></div>
            </div>}
            <div class="absolute top-1/4 w-full">
                <NominationsLeft onScroll={handlescroll}/>
            </div>
        </div>
    );

});

export default Nominate;